import { ChangeDetectionStrategy, Component, Inject, OnInit } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { isEmpty } from "lodash";
import { CONSTANT } from "src/app/constant";
import { CandidateRole } from "src/app/models/enum";
import { OBComments } from "src/app/models/models";
@Component({
	selector: "app-cbta-modal",
	templateUrl: "./cbta-modal.component.html",
	styleUrls: ["./cbta-modal.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CbtaModalComponent implements OnInit {
	readonly CandidateRole = CandidateRole;
	modalName: string = "default";
	showSwitch?: boolean = false;
	modalTitle: string = "";
	modalContent: any;
	modalTraineeAssessmentId: string = "";
	/** Step 3 review — scope View Comments to the active carousel candidate. */
	modalCandidateId: string = "";
	modalBtnConfirmText: string = "Save";
	modalBtnCancelText: string = "Cancel";
	noAction: boolean = false;

	// ob comments model data
	addObComments = new UntypedFormControl("");
	obPilotSwitch = new UntypedFormControl(false);
	newComment!: {
		maneuver: string;
		ob: string;
		action: boolean | null;
		isObservationComment?: boolean;
		candidateName?: string;
		candidateRoleLabel?: string;
		candidateRole?: CandidateRole;
	};
	maneuverOtherComments!: { otherComent: string; maneuver: string };
	signatureData?: { file?: File; dataUrl?: string };
	temComment?: { rating: number; maneuver: string; remarks: string; typeLabel?: string; slotLabel?: string };
	temCommentControl = new UntypedFormControl("");
	signOffData: any = {};
	otherComments: string = "";

	noCloseBtn: boolean = false;
	noSaveBtn: boolean = false;
	modalReviewLayout: boolean = false;
	/** TS1 v3 only — enables inline AI assist toolbar on comment textareas. */
	commentAiAssist = false;
	/** TS1 v3 OB modal only — shows Skip Comment footer button when true. */
	showSkipComment = false;
	/** Checklist remote sign-off — lock Staff Id to authenticated pilot. */
	lockedStaffNumber = "";
	/** TS1 Repeat — choose which candidate to reset. */
	repeatCandidateMessage = "";
	repeatCandidateOptions: Array<{ candidateId: string; label: string; disabled?: boolean }> = [];
	repeatCandidateIdControl = new UntypedFormControl("");

	constructor(
		@Inject(MAT_DIALOG_DATA) private data: any,
		private dialogRef: MatDialogRef<CbtaModalComponent>,
	) {
		dialogRef.disableClose = data.disableClose || false;

		if (data) {
			this.noAction = data.noAction || this.noAction;
			this.noCloseBtn = data.noCloseBtn || this.noCloseBtn;
			this.noSaveBtn = data.noSaveBtn || this.noSaveBtn;
			this.modalName = data.modalName || this.modalName;
			this.modalTitle = data.modalTitle || this.modalTitle;
			this.modalContent = data.modalContent || this.modalContent;
			this.modalBtnCancelText = data.modalBtnCancelText || this.modalBtnCancelText;
			this.modalBtnConfirmText = data.modalBtnConfirmText || this.modalBtnConfirmText;
			this.modalTraineeAssessmentId = data.modalTraineeAssessmentId;
			this.modalCandidateId = data.modalCandidateId ?? "";
			this.modalReviewLayout = data.modalReviewLayout ?? false;
			this.showSwitch = data.showSwitch ?? true;
			this.commentAiAssist = data.commentAiAssist === true;
			this.showSkipComment = data.showSkipComment === true;
			this.lockedStaffNumber = (data.lockedStaffNumber ?? "").toString().trim();
		}

		if (this.modalName === "repeatCandidateModal" && data.modalContent) {
			this.repeatCandidateMessage = String(data.modalContent.message ?? "");
			this.repeatCandidateOptions = Array.isArray(data.modalContent.options) ? data.modalContent.options : [];
			const selected = String(data.modalContent.selectedCandidateId ?? "");
			if (selected) {
				this.repeatCandidateIdControl.setValue(selected);
			}
		}

		if (this.modalName === "obCommentsModel") {
			this.modalContent = this.modalContent.filter((item: OBComments) => item.ob !== "TEM" && item.ob !== "REPEAT");
		}

		if (data.noCloseBtn) {
			this.noCloseBtn = data.noCloseBtn;
		}

		if (data.newComment) {
			this.newComment = data.newComment;
		}

		if (data.initialObComment != null) {
			this.addObComments.setValue(data.initialObComment);
		}

		if (data.maneuverOtherComments) {
			this.maneuverOtherComments = data.maneuverOtherComments;
		}

		if (data.otherComents) {
			this.newComment = data.other;
		}

		if (data.signatureData) {
			this.signatureData = data.signatureData;
		}

		if (data.temComment) {
			this.temComment = data.temComment;
		}

		if (data.initialComment != null) {
			this.temCommentControl.setValue(data.initialComment);
		}
	}

	ngOnInit(): void {}

	onSignatureChange(data: { file?: File; dataUrl?: string }) {
		this.signatureData = data;
	}

	closeModal(): void {
		this.dialogRef.close({ close: false });
	}

	skipComment(): void {
		if (this.modalName !== "obCommentsModel" || !this.showSkipComment) {
			return;
		}
		this.dialogRef.close({ close: true, comment: "", skipped: true });
	}

	onSubmit() {
		// TODO: add condition base on modal name
		if (this.modalName === "obCommentsModel") {
			if (!this.isCommentEmpty()) {
				this.dialogRef.close({
					close: true,
					comment: this.addObComments.value,
					pilotSwitch: this.obPilotSwitch.value ? CONSTANT.CANDIDATE_ROLE.PM : CONSTANT.CANDIDATE_ROLE.PF,
				});

				this.modalContent = this.modalContent.filter((item: OBComments) => item.ob !== "TEM" && item.ob !== "REPEAT");
			}
		} else if (this.modalName === "signaturePadModal") {
			this.dialogRef.close({ close: true, signature: this.signatureData });
		} else if (this.modalName === "temCommentsModal") {
			if (!this.isTemCommentEmpty()) {
				this.dialogRef.close({
					close: true,
					comment: this.temCommentControl.value,
					pilotSwitch: this.obPilotSwitch.value ? CONSTANT.CANDIDATE_ROLE.PM : CONSTANT.CANDIDATE_ROLE.PF,
				});
			}
		} else if (this.modalName === "signOffModal") {
			if (!isEmpty(this.signOffData)) {
				this.dialogRef.close({ close: true, signOffData: this.signOffData });
			}
		} else if (this.modalName === "OtherCommentsModal") {
			if (!this.isOtherCommentEmpty()) {
				this.dialogRef.close({
					close: true,
					otherComments: this.otherComments,
				});
			} else {
				this.dialogRef.close({
					close: true,
					otherComments: this.maneuverOtherComments.otherComent,
				});
			}
		} else if (this.modalName === "OtherTrainingCommentsModal") {
			if (!this.isOtherCommentEmpty()) {
				this.dialogRef.close({
					close: true,
					otherComments: this.otherComments,
				});
			} else {
				this.dialogRef.close({
					close: true,
					otherComments: this.maneuverOtherComments.otherComent,
				});
			}
		} else if (this.modalName === "repeatCandidateModal") {
			const candidateId = String(this.repeatCandidateIdControl.value ?? "").trim();
			if (candidateId) {
				this.dialogRef.close({ close: true, candidateId });
			}
		} else {
			this.dialogRef.close({ close: true });
		}
	}

	isRepeatCandidateConfirmDisabled(): boolean {
		if (this.modalName !== "repeatCandidateModal") return false;
		return !String(this.repeatCandidateIdControl.value ?? "").trim();
	}

	isOtherCommentEmpty(): boolean {
		return this.modalName === "OtherCommentsModal" && isEmpty(this.otherComments.replace(/\s/g, "")) ? true : false;
	}

	isCommentEmpty(): boolean {
		return this.modalName === "obCommentsModel" && isEmpty(this.addObComments.value.replace(/\s/g, "")) ? true : false;
	}

	isTemCommentEmpty(): boolean {
		return this.modalName === "temCommentsModal" && isEmpty(this.temCommentControl.value.replace(/\s/g, ""))
			? true
			: false;
	}

	usesCommentAiToolbar(): boolean {
		return (
			this.commentAiAssist &&
			(this.modalName === "obCommentsModel" ||
				this.modalName === "temCommentsModal" ||
				this.modalName === "OtherCommentsModal" ||
				this.modalName === "OtherTrainingCommentsModal")
		);
	}

	commentLengthLabel(length: number): string {
		return this.commentAiAssist ? `(${length})` : `(${length} / 500)`;
	}

	getCommentMaxLength(): number | null {
		return this.commentAiAssist ? null : 500;
	}

	getSignoffFormValue(value: any) {
		this.signOffData = value;
	}

	getOtherCommentsValue(form: any) {
		console.log("other comments value: ", form.otherComents);
		this.otherComments = form.otherComents;
	}
}
